module.exports = __webpack_public_path__ + "static/media/logo.5ec7c109.png";